module.exports = __webpack_public_path__ + "static/img/jeonbuk-safety-belt.9c8fea6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/jeonbuk-safety-belt.jpg
// module id = AQYH
// module chunks = 0